import EmptyState from "~/components/shared/EmptyState";

export default function ViewNotAvailable() {
  return (
    <div className="w-full">
      <EmptyState
        emoji="ℹ️"
        heading="This view is not available"
        subheading="The Waterfall view has been disabled for this pipeline."
      />
    </div>
  );
}
